import { useState, useEffect } from 'react';
import { ChevronDown, FileText, ExternalLink } from 'lucide-react';

export default function HeroSection() {
    const [showCVOptions, setShowCVOptions] = useState(false);
    const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
    const [displayText, setDisplayText] = useState('');
    const [isTyping, setIsTyping] = useState(true);

    const titles = ['Lecturer', 'Research Consultant', 'PhD', 'Researcher'];

    useEffect(() => {
        let timeout;
        const currentTitle = titles[currentTitleIndex];
        
        if (isTyping) {
            // Typing effect
            if (displayText.length < currentTitle.length) {
                timeout = setTimeout(() => {
                    setDisplayText(currentTitle.slice(0, displayText.length + 1));
                }, 100); // Typing speed
            } else {
                // Finished typing, wait 3 seconds then start untyping
                timeout = setTimeout(() => {
                    setIsTyping(false);
                }, 1500);
            }
        } else {
            // Untyping effect
            if (displayText.length > 0) {
                timeout = setTimeout(() => {
                    setDisplayText(displayText.slice(0, -1));
                }, 50); // Untyping speed (faster)
            } else {
                // Finished untyping, move to next title
                setCurrentTitleIndex((prevIndex) => (prevIndex + 1) % titles.length);
                setIsTyping(true);
            }
        }

        return () => clearTimeout(timeout);
    }, [displayText, isTyping, currentTitleIndex, titles]);

    const handleCVView = (language) => {
        const pdfPath = language === 'arabic' 
            ? '/cv/حمدي-لمامشة.pdf' 
            : '/cv/hamdi-lemamsha-cv-english.pdf';
        
        window.open(pdfPath, '_blank');
        setShowCVOptions(false);
    };

    const handleButtonClick = () => {
        setShowCVOptions(!showCVOptions);
    };

    return (
        <section id="HeroSection" className="hero--section">
            <div className="hero--section--content--box">
                <div className="hero--section-content">
                    <p className="section--title">
                        Hi, I'm Dr. Hamdi Lemamsha!
                    </p>
                    <br></br>
                    <h1 className="hero--section--title">
                        <span className="hero--section-title--color typewriter-text">
                            {displayText}
                            <span className="cursor">|</span>
                        </span>
                    </h1>
                    <br></br>
                </div>
                <div className="cv-download-container">
                    <button 
                        className="cv-download-btn"
                        onClick={handleButtonClick}
                        onBlur={() => {
                            // Reset any stuck active states when button loses focus
                            setTimeout(() => setShowCVOptions(prev => prev), 100);
                        }}
                    >
                        <FileText size={20} />
                        View my CV
                        <ChevronDown size={16} className={`chevron ${showCVOptions ? 'rotated' : ''}`} />
                    </button>
                    
                    {showCVOptions && (
                        <div className="cv-options-dropdown">
                            <button 
                                className="cv-option-btn arabic-btn"
                                onClick={() => handleCVView('arabic')}
                            >
                                <ExternalLink size={16} />
                                    بالعربية 
                            </button>
                            <button 
                                className="cv-option-btn english-btn"
                                onClick={() => handleCVView('english')}
                            >
                                <ExternalLink size={16} />
                                In English
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className="hero--section--img">
                <img src="./img/hero_img.png" alt="Hamdi Lemamsha" />
            </div>
        </section>
    )
}